import { gql } from '@apollo/client'

export const ADMIN_STORE_HISTORY_FRAGMENT = gql`
  fragment AdminStoreHistory on StoreAction {
    id
    action
    employee {
      email
    }
    actionCompletedOn
    numTimesOptimizeHighPerYear
    numTimesOptimizeMediumPerYear
    numTimesOptimizeLowPerYear
    timesPerWeekTwoDScan
  }
`
